import CryptoJS from "crypto-js";
import pako from "pako";
const decClims = (secureClaims) => {

  function decompressData(compressedData) {
    console.log()
    const binaryString = atob(compressedData); // تبدیل Base64 به باینری
    const charData = binaryString.split("").map((x) => x.charCodeAt(0));
    const binData = new Uint8Array(charData);
    try {
      const decompressed = pako.ungzip(binData, { to: "string" });
      return decompressed;
    } catch (err) {
      // console.log("Error during decompression:", err);
      return null;
    }
  }

  function decryptAndDecompress(encryptedCompressedData, key) {

    // 2. باز کردن فشرده‌سازی
    const decompressedData = decompressData(encryptedCompressedData);
   
    
    return JSON.parse(decompressedData);
  }


  const encryptionKey = "secret_key_rasam";
  const securClaims = decryptAndDecompress(secureClaims, encryptionKey);
  return securClaims;

  
};
export default decClims;
